import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-denied-full',
  templateUrl: './access-denied-full.component.html',
  styleUrls: ['./access-denied-full.component.css']
})
export class AccessDeniedFullComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/error/access-denied-full/access-denied-full.component.ts